import { DatasetDefinition, DocumentSpecificHiddenFields, HiddenFields, OpenFieldType } from '../../../datasets/store/types';

export enum ClientDatasetActionTypes {
    FETCH_ALL_CLIENT_DATASETS_STARTED = 'FETCH_ALL_CLIENT_DATASETS_STARTED',
    FETCH_ALL_CLIENT_DATASETS_SUCCESSFUL = 'FETCH_ALL_CLIENT_DATASETS_SUCCESSFUL',
    FETCH_ALL_CLIENT_DATASETS_FAILED = 'FETCH_ALL_CLIENT_DATASETS_FAILED',
    REDIRECT_MY_DATASET = 'REDIRECT_MY_DATASET',
    CLIENT_DATASET_VIEW = 'CLIENT_DATASET_VIEW',
    FETCH_CLIENT_DATASET_DEFINITIONS_STARTED = 'FETCH_CLIENT_DATASET_DEFINITIONS_STARTED',
    FETCH_CLIENT_DATASET_DEFINITIONS_SUCCESSFUL = 'FETCH_CLIENT_DATASET_DEFINITIONS_SUCCESSFUL',
    FETCH_CLIENT_DATASET_DEFINITIONS_FAILED = 'FETCH_CLIENT_DATASET_DEFINITIONS_FAILED',
    REMOVE_CLIENT_DATASETS_OPEN_FIELD_SECTION = 'REMOVE_MY_DATASETS_OPEN_FIELD_SECTION',
    ADD_CLIENT_DATASETS_OPEN_FIELD_SECTION = 'ADD_CLIENT_DATASETS_OPEN_FIELD_SECTION',
    REMOVE_ALL_CLIENT_DATASETS_FIELD_SECTIONS = 'REMOVE_ALL_CLIENT_DATASETS_FIELD_SECTIONS',
    RESET_CLIENT_DATASETS = 'RESET_CLIENT_DATASETS',
    TOGGLE_MODAL_DATASET_ID = 'TOGGLE_MODAL_DATASET_ID',
    TOGGLE_HIDDEN_FIELDS = 'TOGGLE_HIDDEN_FIELDS',
    SAVE_HIDDEN_FIELDS_STARTED = 'SAVE_HIDDEN_FIELDS_STARTED',
    SAVE_HIDDEN_FIELDS_SUCCESSFUL = 'SAVE_HIDDEN_FIELDS_SUCCESSFUL',
    SAVE_HIDDEN_FIELDS_FAILED = 'SAVE_HIDDEN_FIELDS_FAILED',
    HIDDEN_FIELDS_HAVE_UPDATED = 'HIDDEN_FIELDS_HAVE_UPDATED',
    TOGGLE_UNSAVED_CHANGES_MODAL = 'TOGGLE_CLIENT_DATASETS_UNSAVED_CHANGES_MODAL'
}

export enum ClientDatasetView {
    LIST = 'List',
    PREVIEW = 'Preview',
    CONFIGURE = 'Configure'
}

export interface ClientDatasets {
    datasetId: number;
    documentNames: string[];
    agreementTypeId: number;
    agreementType: string;
}

export interface ClientDatasetsOpenField {
    sectionId?: string;
    rowId?: string;
    fieldId: string;
    datasetId: string;
    groupIndex?: number;
    type: OpenFieldType.FIELD;
}

export interface ClientDatasetsOpenSection {
    sectionId: string;
    datasetId: string;
    type: OpenFieldType.SECTION;
}

export type ClientDatasetsOpenFieldSection = ClientDatasetsOpenField | ClientDatasetsOpenSection;

export interface ClientDatasetsState {
    allDatasets: ClientDatasets[];
    fetchingAllDatasets: boolean;
    datasetView: ClientDatasetView;
    selectedDataset: number | null;
    datasetDefinitions: DatasetDefinition[];
    openFieldsAndSections: ClientDatasetsOpenFieldSection[];
    modalDatasetId: number | null;
    savedHiddenFields: HiddenFields;
    currentHiddenFields: HiddenFields;
    isSaving: boolean;
    hiddenFieldsUpdated: boolean;
    unsavedChangesModalOpen: boolean;
    fetchingDatasetDefinitions: boolean;
    documentHiddenFields: DocumentSpecificHiddenFields;
}
